import { AdminTenantLocation } from '@hakimo-ui/hakimo/types';
import { BasicPanel } from '@hakimo-ui/hakimo/ui-elements';
import { Table } from '@hakimo-ui/hakimo/ui-table';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getLocationsTableData } from '../util';

interface Props {
  locations: AdminTenantLocation[];
  supportUserEmail: string | null;
  onClickCreate?: () => void;
}

export function LocationsTableCard(props: Props) {
  const { locations, supportUserEmail } = props;
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();

  const onClickRow = useCallback(
    (locationId: string, event: React.MouseEvent | React.KeyboardEvent) => {
      const url = `/tenants-admin/${tenantId}/locations/${locationId}`;
      const isNewTab = event.ctrlKey || event.metaKey;
      if (isNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        navigate(url);
      }
    },
    [navigate, tenantId]
  );

  const tableData = useMemo(
    () => getLocationsTableData(locations, onClickRow),
    [locations, onClickRow]
  );

  if (locations.length === 0) {
    return (
      <BasicPanel title="Locations">
        <div className="p-4">
          <Alert type="info" size="small">
            Please access hakimo portal with tenant support account{' '}
            {supportUserEmail && <strong>{supportUserEmail}</strong>} to create
            location for this tenant.
          </Alert>
        </div>
      </BasicPanel>
    );
  }

  return (
    <BasicPanel title="Locations">
      <Table data={tableData} embedded />
    </BasicPanel>
  );
}

export default LocationsTableCard;
